/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.05 0c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24-10.766-24-24-24zm0 42.891C13.627 42.891 5.159 34.423 5.159 24c0-10.423 8.468-18.891 18.891-18.891 10.423 0 18.891 8.468 18.891 18.891 0 10.423-8.468 18.891-18.891 18.891z"/><path pid="1" d="M26.519 21.486h8.798v5.039h-8.798v8.798H21.48v-8.798h-8.799v-5.039h8.799v-8.798l5.039-.001v8.799z" fill-rule="nonzero"/>'
}
